import React, { useState, useRef, useEffect } from "react";
import { MediaRecorder, register } from 'extendable-media-recorder';
import { connect } from 'extendable-media-recorder-wav-encoder';
import axios from "axios";
import uuid from 'react-native-uuid';
import { useDispatch, useSelector } from 'react-redux'
// import { setBnText, setEnText, setEntity, setResult, setSession, resetSession, setChatReply, setChatReplyEn, setCost } from './asrSlice'
import { setId, setResponse, setResponseTag, setTimeTaken, setProbability, setUserInput, setIsRelevant, setSession, resetSession, setAsrTime, setChatTime } from '../ec-chat-page/ecChatSlice'
import Button from 'react-bootstrap/Button';
import { hideLoader, showLoader } from '../loader/loaderSlice';

const AudioRecorderChatEC = () => {
    const dispatch = useDispatch()
    const [permission, setPermission] = useState(false);
    const mediaRecorder = useRef(null);
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [stream, setStream] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [audio, setAudio] = useState(null);

    const ecChatId = useSelector((state) => {
        console.log("Full Redux State:", state); // Log the entire Redux state
        return state.ecChat?.ecChatId;
    });

    const appToken = useSelector((state) => state.auth?.appToken);

    useEffect(() => {
        console.log("EC Chat ID:", ecChatId); // Log the ecChatId whenever it changes
    }, [ecChatId]);

    const getMicrophonePermission = async () => {
        if ("MediaRecorder" in window) {
            try {
                await register(await connect());
                const streamData = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                setPermission(true);
                setStream(streamData);
                console.log("Permission is provided");
            } catch (err) {
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }
    };

    const startRecording = async () => {
        dispatch(resetSession());
        setRecordingStatus("recording");
        const media = new MediaRecorder(stream, { mimeType: 'audio/wav' });
        mediaRecorder.current = media;
        mediaRecorder.current.start();
        let localAudioChunks = [];
        mediaRecorder.current.ondataavailable = (event) => {
            if (typeof event.data === "undefined") return;
            if (event.data.size === 0) return;
            localAudioChunks.push(event.data);
        };
        setAudioChunks(localAudioChunks);
    };

    const stopRecording = async () => {
        setRecordingStatus("inactive");
        mediaRecorder.current.stop();
        mediaRecorder.current.onstop = async () => {
            const audioBlob = new Blob(audioChunks, { type: audioChunks[0].type });
            const audioUrl = window.URL.createObjectURL(audioBlob);
            const fileNameText = uuid.v4();
            const fileName = fileNameText + ".wav";

            setAudio(audioUrl);
            setAudioChunks([]);

            // Convert audio to 8000Hz before uploading
            const convertedAudioFile = await convertAudioTo8000Hz(audioBlob, fileName);
            uploadAudio(convertedAudioFile, fileNameText);
        };
    };

    const convertAudioTo8000Hz = async (audioBlob, fileName) => {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const arrayBuffer = await audioBlob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        
        // Create offline context for resampling
        const offlineContext = new OfflineAudioContext(
            1, // mono
            audioBuffer.duration * 8000,
            8000 // target sample rate
        );

        // Create buffer source
        const source = offlineContext.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(offlineContext.destination);
        source.start();

        // Render the audio
        const renderedBuffer = await offlineContext.startRendering();

        // Convert to WAV
        const length = renderedBuffer.length * 2; // 16-bit samples
        const buffer = new ArrayBuffer(44 + length);
        const view = new DataView(buffer);

        // Write WAV header
        writeString(view, 0, 'RIFF');
        view.setUint32(4, 36 + length, true);
        writeString(view, 8, 'WAVE');
        writeString(view, 12, 'fmt ');
        view.setUint32(16, 16, true);
        view.setUint16(20, 1, true);
        view.setUint16(22, 1, true);
        view.setUint32(24, 8000, true);
        view.setUint32(28, 16000, true);
        view.setUint16(32, 2, true);
        view.setUint16(34, 16, true);
        writeString(view, 36, 'data');
        view.setUint32(40, length, true);

        // Write audio data
        const data = new Float32Array(renderedBuffer.getChannelData(0));
        let offset = 44;
        for (let i = 0; i < data.length; i++) {
            const sample = Math.max(-1, Math.min(1, data[i]));
            view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
            offset += 2;
        }

        return new File([buffer], fileName, { type: 'audio/wav' });
    };

    const writeString = (view, offset, string) => {
        for (let i = 0; i < string.length; i++) {
            view.setUint8(offset + i, string.charCodeAt(i));
        }
    };

    const uploadAudio = async (audioFile, fileName) => {
        const formData = new FormData();
        formData.append("file", audioFile);
        formData.append("ecChatId", ecChatId);
        dispatch(showLoader());

        axios
            .post(`${process.env.REACT_APP_BACKEND_URL_EC}/api/ec-asr-chat-test`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "X-API-KEY": appToken
                },
            })
            .then((response) => {
                console.log(response);
                dispatch(setId(response.data.id));
                dispatch(setResponse(response.data.response));
                dispatch(setResponseTag(response.data.response_tag));
                dispatch(setTimeTaken(response.data.time_taken));
                dispatch(setAsrTime(response.data.asrTime));
                dispatch(setChatTime(response.data.chatTime));
                dispatch(setProbability(response.data.probability));
                dispatch(setUserInput(response.data.user_input));
                dispatch(setIsRelevant(response.data.is_relevant));

                dispatch(hideLoader()); 
                dispatch(setSession(fileName));  
            })
            .catch((error) => {
                console.log(error);
                dispatch(hideLoader());
                dispatch(resetSession()); 
            });
    };

    return (
        <div className='recorder mini-card'>
            <h4>EC Audio Recorder</h4>
            <main>
                <div className="audio-controls">
                    {!permission ? (                        
                        <Button
                            variant="outline-dark" size="sm" onClick={getMicrophonePermission}>Get Microphone</Button>
                    ) : null}
                    {permission && recordingStatus === "inactive" ? (
                        <Button
                            variant="outline-dark" size="sm" onClick={startRecording}>Start Recording</Button>
                    ) : null}
                    {recordingStatus === "recording" ? (
                        <Button
                            variant="outline-dark" size="sm" onClick={stopRecording}>Stop Recording</Button>
                    ) : null}
                </div>
                {audio ? (
                    <div className="audio-container">
                        <br />
                        <audio src={audio} controls></audio>                        
                    </div>
                ) : null}
            </main>
        </div>
    );
};

export default AudioRecorderChatEC;
